<template>
  <div class='flexBox flexBox-r'>
    <div class='process'  :style="{width}">
      <div class='barView' :style="{width: percent}"></div>
    </div>
    <div>{{percent}}</div>
  </div>
</template>
<script>
export default {
  name: 'progressview',
  props: {
    percent: {
      type: String,
      default: '0%'
    },
    width: {
      type: String,
      default: '5em'
    }
  }
}
</script>
<style lang="scss" scoped>
.flexBox{
  display: flex;
  align-items: center;
} 
.flexBox-r{
  flex-direction: row;
}
.process{
  height: .5em;
  background-color: rgba(0,0,0,.05);
  overflow: hidden;
  border-radius: 1em;
  margin-right: 1em;
  position: relative;
  .barView{
    background-color: $blueLight;
    height: .5em;
    border-radius: 1em;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Progress.vue